import { useApp } from "../context/AppContext";
import en from "../locales/en.json";
import zh from "../locales/zh.json";
import ja from "../locales/ja.json";
import ko from "../locales/ko.json";
import es from "../locales/es.json";
import vi from "../locales/vi.json";
import de from "../locales/de.json";
import fr from "../locales/fr.json";

export const DICTS = { en, zh, ja, ko, es, vi, de, fr };

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
  { code: "es", label: "Español" },
  { code: "vi", label: "Tiếng Việt" },
  { code: "de", label: "Deutsch" },
  { code: "fr", label: "Français" },
];

export const CURRENCIES = [
  { code: "USD", symbol: "$", flag: "🇺🇸" },
  { code: "CNY", symbol: "¥", flag: "🇨🇳" },
  { code: "EUR", symbol: "€", flag: "🇪🇺" },
];

export const translate = (lang, key) => DICTS[lang]?.[key] ?? en[key] ?? key;

// Gettext-style UI catalog (source-English keys) — see /app/scripts/i18n_codemod.js and translate_ui.py
const UI = { en: {} };
let CUR = "en";
export const LOCALES = { en: "en-US", zh: "zh-CN", ja: "ja-JP", ko: "ko-KR", es: "es-ES", vi: "vi-VN", de: "de-DE", fr: "fr-FR" };
export const loadUi = async (l) => {
  if (!LOCALES[l]) l = "en";
  if (l !== "en" && !UI[l]) UI[l] = (await import(`../locales/ui/${l}.json`)).default;
  CUR = l;
  return l;
};
export const txLocale = () => LOCALES[CUR];
export const soldLabel = (n) => (n > 0 ? txf("{0} sold", new Intl.NumberFormat(LOCALES[CUR], { notation: n >= 1000 ? "compact" : "standard", maximumFractionDigits: 1 }).format(n) + (n >= 1000 ? "+" : "")) : null);
export const tx = (v) => {
  if (typeof v !== "string" || CUR === "en") return v;
  const k = v.replace(/\s+/g, " ").trim();
  const r = UI[CUR]?.[k];
  if (!r) return v;
  return v.match(/^\s*/)[0] + r + v.match(/\s*$/)[0];
};
export const txf = (tpl, ...args) => {
  const r = (CUR !== "en" && UI[CUR]?.[tpl]) || tpl;
  return r.replace(/\{(\d+)\}/g, (_, i) => (args[i] ?? ""));
};
const PAT = {};
export const txMsg = (m) => {
  if (typeof m !== "string" || CUR === "en") return m;
  const direct = tx(m);
  if (direct !== m) return direct;
  if (!PAT[CUR]) PAT[CUR] = Object.keys(UI[CUR] || {}).filter((k) => /\{\d\}/.test(k)).map((k) => [new RegExp("^" + k.replace(/[.*+?^$()|[\]\\]/g, "\\$&").replace(/\\?\{(\d)\\?\}/g, "(.+?)") + "$"), k]);
  for (const [re, k] of PAT[CUR]) { const g = m.match(re); if (g) return txf(k, ...g.slice(1)); }
  return m;
};
export const uiDict = (l) => UI[l];
export const useLang = () => useApp().lang;
